// Industry-flavoured icon picks. The default Boxes/Wrench icons are generic;
// when we know the industry we surface something the owner immediately
// recognises (a target for a rifle club, scissors for a barber, etc).

import {
  Boxes,
  ChefHat,
  Crosshair,
  Hammer,
  Scissors,
  ShoppingBag,
  Stethoscope,
  Sparkles,
  Truck,
  Utensils,
  Wine,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

export interface IndustryIconSet {
  inventory: LucideIcon;
  assets: LucideIcon;
}

export function iconsForIndustry(industry: string | null | undefined): IndustryIconSet {
  const i = (industry ?? '').toLowerCase();

  if (i.includes('rifle') || i.includes('sport') || i.includes('shoot') || i.includes('club')) {
    return { inventory: Crosshair, assets: Crosshair };
  }
  if (
    i.includes('dental') ||
    i.includes('clinic') ||
    i.includes('healthcare') ||
    i.includes('medical')
  ) {
    return { inventory: Stethoscope, assets: Stethoscope };
  }
  if (
    i.includes('restaurant') ||
    i.includes('hospitality') ||
    i.includes('food') ||
    i.includes('cafe') ||
    i.includes('bar')
  ) {
    return { inventory: Utensils, assets: ChefHat };
  }
  if (i.includes('beauty') || i.includes('salon') || i.includes('barber')) {
    return { inventory: Scissors, assets: Sparkles };
  }
  if (
    i.includes('retail') ||
    i.includes('tuck') ||
    i.includes('shop') ||
    i.includes('fashion') ||
    i.includes('fragrance') ||
    i.includes('perfume') ||
    i.includes('clothing') ||
    i.includes('tailor') ||
    i.includes('shoe')
  ) {
    return { inventory: ShoppingBag, assets: ShoppingBag };
  }
  if (i.includes('construction') || i.includes('material') || i.includes('builder')) {
    return { inventory: Hammer, assets: Wrench };
  }
  if (i.includes('transport') || i.includes('kombi') || i.includes('logistics')) {
    return { inventory: Truck, assets: Truck };
  }
  if (i.includes('wine') || i.includes('liquor') || i.includes('beverage')) {
    return { inventory: Wine, assets: Wine };
  }

  // Generic fallback
  return { inventory: Boxes, assets: Wrench };
}
